module.exports = __webpack_public_path__ + "static/media/72.ae134e8d.gif";